import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import SectionReveal from "../components/SectionReveal";

const NAVY = "#102B63";
const SOFT_TEXT = "#4A5E84";
const CTA_ORANGE = "#F5A623";

const solutionTypes = [
  "Applications métier",
  "Outils internes",
  "Automatisation de processus",
  "Plateformes digitales",
];

const approachSteps = [
  "Analyse des besoins",
  "Conception sur mesure",
  "Développement et intégration",
  "Accompagnement et évolution",
];

function ServiceCard({ title, items }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: { xs: 3.5, md: 4 },
        bgcolor: "rgba(255,255,255,0.98)",
        border: "1px solid rgba(16,43,99,0.08)",
        boxShadow: "0 14px 34px rgba(16,43,99,0.05)",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Box sx={{ p: { xs: 3, md: 3.6 }, minHeight: { xs: 255, md: 285 } }}>
        <Box
          sx={{
            px: { xs: 0.35, md: 0.8 },
            pt: { xs: 0.4, md: 0.6 },
          }}
        >
          <Typography
            sx={{
              color: NAVY,
              fontWeight: 800,
              mb: 1.5,
              lineHeight: 1.3,
              fontSize: { xs: "1rem", md: "1.08rem" },
              maxWidth: "94%",
            }}
          >
            {title}
          </Typography>

          <Stack spacing={1.08}>
            {items.map((item) => (
              <Typography
                key={item}
                sx={{
                  color: SOFT_TEXT,
                  lineHeight: 1.84,
                  fontSize: { xs: "0.97rem", md: "1rem" },
                  maxWidth: "95%",
                  pr: { xs: 0.2, md: 0.4 },
                }}
              >
                • {item}
              </Typography>
            ))}
          </Stack>
        </Box>
      </Box>
    </Paper>
  );
}

export default function ServicesPage() {
  return (
    <Box sx={{ pt: { xs: 4, md: 6 }, pb: { xs: 7, md: 9 } }}>
      <Container maxWidth="xl">
        <SectionReveal>
          <Typography
            sx={{
              color: CTA_ORANGE,
              fontWeight: 800,
              mb: 1,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
            }}
          >
            Nos services
          </Typography>

          <Typography
            variant="h2"
            sx={{
              color: NAVY,
              mb: 2,
              fontWeight: 800,
              lineHeight: 1.08,
              letterSpacing: "-0.03em",
            }}
          >
            Développer des solutions adaptées à vos enjeux métiers
          </Typography>

          <Typography
            sx={{
              color: SOFT_TEXT,
              lineHeight: 1.9,
              maxWidth: 980,
              mb: 4,
              fontSize: { xs: "1rem", md: "1.04rem" },
            }}
          >
            Nous concevons et développons des solutions spécifiques pour répondre
            à vos besoins métiers, optimiser vos processus et améliorer votre
            performance opérationnelle.
          </Typography>
        </SectionReveal>

        <SectionReveal delay={0.05}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: { xs: 2.2, md: 2.8 },
            }}
          >
            <ServiceCard title="Types de solutions" items={solutionTypes} />
            <ServiceCard title="Approche" items={approachSteps} />
          </Box>
        </SectionReveal>
      </Container>
    </Box>
  );
}